export default "__VITE_ASSET__B2AKyjoC__"